import { Component } from "@angular/core";

@Component({
	selector: "caass-dynamicReport",
	templateUrl: "./dynamicReport.component.html",
})
export class DynamicReportComponent {}
